import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    backToDeviceList: 'Back to the list of devices',
    description:
      'The device has been disconnected from your Shine account. You will no longer be able to log in.\nAs a precaution, we recommend you change your access code.',
    title: 'Device blocked and disconnected',
  },
  fr: {
    backToDeviceList: 'Retour à la liste de mes appareils',
    description:
      'L’appareil a été déconnecté de votre compte Shine. Vous ne pourrez plus vous y connecter.\nPar mesure de précaution vous devriez changer votre code d’accès.',
    title: 'Appareil bloqué et déconnecté',
  },
});

export default locales;
